import React from 'react';
import {
  Container, AppBar, Toolbar, Typography, Button, Box, Avatar, Stack, useMediaQuery,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import Calendar from './Calendar';
import { authAPI } from '../api';

function Dashboard({ user, onLogout }) {
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleLogout = async () => {
    try {
      await authAPI.logout();
      onLogout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const avatarUrl =
    user.avatar && user.discordId
      ? `https://cdn.discordapp.com/avatars/${user.discordId}/${user.avatar}.png?size=64`
      : undefined;

  return (
    <>
      <AppBar position="sticky">
        <Toolbar sx={{ gap: 1.5 }}>
          <img
            src="/dnd-logo.png"
            alt="D&D Logo"
            style={{ width: 30, height: 30, filter: 'drop-shadow(0 2px 6px rgba(216,53,42,0.5))' }}
          />
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, fontFamily: '"Cinzel", serif', fontWeight: 600, letterSpacing: '0.05em', fontSize: { xs: '1rem', sm: '1.2rem' } }}
          >
            D&amp;D Planner
          </Typography>

          <Stack direction="row" spacing={1.25} alignItems="center">
            {!isMobile && (
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {user.username}
              </Typography>
            )}
            <Avatar src={avatarUrl} sx={{ width: 32, height: 32, bgcolor: 'primary.dark', fontSize: '0.9rem' }}>
              {user.username ? user.username.charAt(0).toUpperCase() : '?'}
            </Avatar>
            <Button
              variant="outlined"
              size="small"
              onClick={handleLogout}
              startIcon={!isMobile ? <LogoutIcon sx={{ fontSize: 18 }} /> : null}
              sx={{ minWidth: 0, px: isMobile ? 1 : 2 }}
            >
              {isMobile ? <LogoutIcon sx={{ fontSize: 18 }} /> : 'Logout'}
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>

      <Box component="main" sx={{ py: { xs: 3, sm: 5 } }}>
        <Container maxWidth="lg">
          <Calendar />
        </Container>
      </Box>
    </>
  );
}

export default Dashboard;
